import React from "react";
import CommingSoon from "../review/CommingSoon";
import AnalyticsTopNav from "./AnalyticsTopNav";

const Selling = () => {
  return (
    <div>
      <AnalyticsTopNav />
      <CommingSoon
        title="서비스를 준비 중이에요."
        desc="사장님의 매장 운영에 도움을 드릴 수 있는 <br />
        분석 서비스를 위해 열심히 노력하고 있어요. <br />
        기대해주세요!"
      />
    </div>
  );
};

export default Selling;
